import { render, staticRenderFns } from "./actividades_curso.vue?vue&type=template&id=34c8a9be"
import script from "./actividades_curso.vue?vue&type=script&lang=js"
export * from "./actividades_curso.vue?vue&type=script&lang=js"
import style0 from "./actividades_curso.vue?vue&type=style&index=0&id=34c8a9be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports